<template>
  <div>
    <a-modal
      title="Room Arrangements Edit"
      :visible="roomNum !== null"
      :maskClosable="false"
      @cancel="handleRoomArrangementsModalCancel"
      width="800px"
      :dialog-style="{ top: '20px' }"
    >
      <a-form layout='horizontal' :form="editForm">
        <!-- Room Type -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Room Type"
        >
          <a-input
            v-decorator="[
              'roomType',
              {
                rules: [
                  { max: 100, message: 'Max length 100' },
                  { required: false, message: 'Please input your room type!' },
                ]
              }
            ]"
            placeholder="Please input your room type"
          />
        </a-form-item>
        <!-- Size -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Size"
        >
          <a-row :gutter="24">
            <a-col :span="6">
              <a-input
                v-decorator="[
                  'roomSizeLong',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your size!' },
                    ]
                  }
                ]"
                placeholder="Please input your size"
              />
            </a-col>
            <a-col :span="1" style="padding: 0px;text-align: center;"> ~ </a-col>
            <a-col :span="6">
              <a-input
                v-decorator="[
                  'roomSizeWide',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your size!' },
                    ]
                  }
                ]"
                placeholder="Please input your size"
              />
            </a-col>
            <a-col :span="1" style="padding: 0px;">m<sup>2</sup></a-col>
            <a-col :span="6">
              <a-input
                v-decorator="[
                  'roomSizeTatami',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your size!' },
                    ]
                  }
                ]"
                placeholder="Please input your size"
              />
            </a-col>
            <a-col :span="3" style="padding: 0px;">Tatami</a-col>
          </a-row>
        </a-form-item>
        <!-- Twin -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Twin"
        >
          <a-row :gutter="8">
            <a-col :span="8">
              <a-input
                v-decorator="[
                  'twinLong',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your twin!' },
                    ]
                  }
                ]"
                placeholder="Please input your twin"
              />
            </a-col>
            <a-col :span="1" style="text-align: center;"> x </a-col>
            <a-col :span="8">
              <a-input
                v-decorator="[
                  'twinWide',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your twin!' },
                    ]
                  }
                ]"
                placeholder="Please input your twin"
              />
            </a-col>
            <a-col :span="6"> cm * 2 bed</a-col>
          </a-row>
        </a-form-item>
        <!-- Double -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Double"
        >
          <a-row :gutter="8">
            <a-col :span="8">
              <a-input
                v-decorator="[
                  'doubleLong',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your double!' },
                    ]
                  }
                ]"
                placeholder="Please input your double"
              />
            </a-col>
            <a-col :span="1" style="text-align: center;"> x </a-col>
            <a-col :span="8">
              <a-input
                v-decorator="[
                  'doubleWide',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your double!' },
                    ]
                  }
                ]"
                placeholder="Please input your double"
              />
            </a-col>
            <a-col :span="6"> cm * 1 bed</a-col>
          </a-row>
        </a-form-item>
        <!-- Triple -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Triple"
        >
          <a-row>
            <a-col :span="4"> Arranged with</a-col>
            <a-col :span="20">
              <a-input
                v-decorator="[
                  'tripleNote',
                  {
                    rules: [
                      { max: 100, message: 'Max length 100' },
                      { required: false, message: 'Please input your triple!' },
                    ]
                  }
                ]"
                placeholder="Please input your triple"
              />
            </a-col>
          </a-row>
        </a-form-item>
        <!-- Chinese Note -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Chinese Note"
        >
          <a-input
            v-decorator="[
              'twNote',
              {
                rules: [
                  { max: 300, message: 'Max length 300' },
                  { required: false, message: 'Please input your chinese note!' },
                ]
              }
            ]"
            placeholder="Please input your chinese note"
          />
        </a-form-item>
        <!-- English Note -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="English Note"
        >
          <a-input
            v-decorator="[
              'enNote',
              {
                rules: [
                  { max: 300, message: 'Max length 300' },
                  { required: false, message: 'Please input your english note!' },
                ]
              }
            ]"
            placeholder="Please input your english note"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleRoomArrangementsModalConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'HotelRoomArrangements',
  components: {
  },
  props: {
    roomNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleRoomArrangementsModalCancel () {
      this.$emit('cancel')
    },
    handleRoomArrangementsModalConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
</style>